export function ArticleCategories({ categories }: { categories?: string[] }) {
  if (!categories?.length) return <span className="category-empty">未分類</span>;

  return (
    <span className="article-categories" aria-label={`文章分類：${categories.join("、")}`}>
      {categories.map((category) => (
        <span className="category-tag" key={category}>
          {category}
        </span>
      ))}
    </span>
  );
}
